import { Component, input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { GoodStateComponent } from './states/good-state.component';
import { BadStateComponent } from './states/bad-state.component';
import { NeedsReviewStateComponent } from './states/needs-review-state.component';
import { IconComponent } from '../icon/icon.component';
import { type SlideScanDisplayClass } from '../../util/get-display-class-for-slide-scan-status';

@Component({
  selector: 'dpqa-state-transition',
  standalone: true,
  imports: [CommonModule, GoodStateComponent, BadStateComponent, NeedsReviewStateComponent, IconComponent],
  templateUrl: './state-transition.component.html',
  styleUrl: './state-transition.component.less',
})
export class StateTransitionComponent {
  public from = input<SlideScanDisplayClass>();
  public to = input<SlideScanDisplayClass>();
}
